import { useEffect, useRef, useState } from "react";
import QRCode from "react-qr-code";
import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import { apiFetch } from "../lib/apiFetch";

type QrAbsen = {
    api_status: number,
    api_message: string,
    data? :{
        token: string
    }
}
export default function QrAbsen() {
    const valuetoken = useRef<string>("")
    const [valuetokenState, setValuetokenState] = useState<string>("")
    const baseurl = import.meta.env.VITE_KOPILIBRASI_URL
    const baseurlabsen = import.meta.env.VITE_KOPILIBRASI_URL_ABSEN
    const fetchQrCode = async (deviceid: string) => {
        try {
            const response = await apiFetch(baseurl + `/qr_absen?device_id=${deviceid}`,
                {
                    method: "GET",
                    headers: {
                        "Accept" : "application/json",
                        "Content-Type": "application/json",
                    },
                }
            );
            const data = await response.json() as QrAbsen;
            if(data.api_status == 1){
                // valuetoken.current = baseurl + "/absen/?token=" + data.data.token
                valuetoken.current = baseurlabsen + "/absen/?token=" + data.data!.token
                setValuetokenState(valuetoken.current)
            }
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        getCurrentBrowserFingerPrint().then((v) => {
            fetchQrCode(v)
        })
        
    },[])
    return (
        <div className="h-screen w-screen bg-slate-200 pt-36">
            <div className="bg-white rounded-3xl">
                <div className="flex flex-col px-6 py-8 sm:p-10 sm:pb-6 items-center">
                    <h2 className="text-lg font-medium text-gray-600 lg:text-3xl text-center">
                        Silahkan scan untuk absen
                    </h2>
                    <div className="mt-8">
                        {
                            valuetoken.current != "" ?
                            <QRCode value={valuetokenState.toString()}></QRCode>
                            : <h3>Anda bukan admin</h3>
                        }
                        
                    </div>
                </div>
            </div>
            {/* <div className="flex flex-col bg-white rounded-3xl mt-10">
                <div className="px-6 py-8 sm:p-10 sm:pb-6">
                    <div className="grid items-center justify-center w-full grid-cols-1 text-left">
                        <h1>QR Absen</h1>
                    </div>
                </div>
            </div> */}
        </div>
    )
}